import React, { FC } from 'react';
import RichText from '../richtext';
import Styles from './StaticProductEntitle.module.scss';
import ToolTip from '../ToolTip/ToolTip';
import { StaticExclusiveBenefitsSchema } from './StaticProductDatatypes';
import { EXCLUSIVE_BENEFIT_COLOR } from '../../utils/constants';

const StaticBenefit: FC<StaticExclusiveBenefitsSchema> = ({ content }) => {
  const benefitData = (option: any) => {
    return (
      <span className={Styles.exclusiveOptionWrapper}>
        {option?.icon?.filename && (
          <img src={option?.icon?.filename} width={24} height={24} alt='exclusive benefit icon' />
        )}
        <span className={`${Styles.text} ms-2`}>
          <RichText content={option?.title} />
        </span>
      </span>
    );
  };

  return (
    <div>
      <div
        className={Styles.exclusiveOptionContainer}
        style={{ backgroundColor: content?.backgrundColor ?? EXCLUSIVE_BENEFIT_COLOR }}
      >
        <div className={Styles.exclusiveOptionList}>
          {content?.title && <span className={Styles.exclusiveOptionTitle}>{content?.title}</span>}
          {(content?.extraBenefits || []).map((option: any, i: number) => {
            return (
              <div key={i} className='d-flex justify-content-between align-items-center'>
                {option && <>{benefitData(option)}</>}
                {option?.tooltip && <span className={Styles.exclusiveToolTipContainer}>
                  <ToolTip content={option?.tooltip} isBenefit={true} />
                </span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StaticBenefit;
